import { Command } from '@/app/common/base/command'

export class ClearDomainCommand extends Command {
    public async run() {
        await this.store.dispatch('license/clearDomain')
    }
}
